import React from 'react';

import { type LBIcon } from '@/assets/icons/icons';

import { YStack } from './layout/layout';

interface TileProps {
  icon?: LBIcon;
  title: string;
  description: string;
  content: React.ReactElement;
  leadingContent?: React.ReactElement;
  titleClassName?: string;
  descriptionClassName?: string;
}

export default function Tile({
  icon,
  title,
  description,
  content,
  leadingContent,
  titleClassName = '',
  descriptionClassName = '',
}: TileProps) {
  return (
    <div className="h-full max-h-[80vh] overflow-auto w-full max-w-[560px] px-6 py-8 flex flex-col gap-8">
      {icon &&
        React.createElement(icon, {
          size: 48,
          className: 'text-foreground self-center',
        })}
      <YStack className="gap-2 items-center text-center">
        {leadingContent && leadingContent}
        <p className={`text-xl text-foreground font-medium ${titleClassName}`}>
          {title}
        </p>
        <p className={`text-sm text-foreground-muted ${descriptionClassName}`}>
          {description}
        </p>
      </YStack>
      <div>{content}</div>
    </div>
  );
}
